import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);


import AppHome from '@/components/AppHome';
import AppIntroduction from '@/components/AppIntroduction';
import AppCase from '@/components/AppCase';
import AppConstract from '@/components/AppConstract';
import AppIShow from '@/components/AppIShow';
import AppQhudong from '@/components/AppQhudong';
import AppSign from '@/components/AppSign';
import AppLive from '@/components/AppLive';


let routes=[
  {path:'/home',component:AppHome},
  {path:'/intro',component:AppIntroduction},
  {path:'/case',component:AppCase},
  {path:'/constract',component:AppConstract},
  {path:'/ishow',component:AppIShow},
  {path:'/qhudong',component:AppQhudong},
  {path:'/sign',component:AppSign},
  {path:'/live',component:AppLive},
  {path:'/',redirect:'/home'}
];

const router = new VueRouter({routes});

export default router;